import { Check } from 'lucide-react';

const trustItems = [
  'Only recommend what you need',
  'Certified Mopar\u00AE Technicians',
  'We keep you in the loop',
  'Realistic timelines, every visit'
];

export default function TrustBar() {
  return (
    <section className="border-t border-border-subtle bg-canvas-default px-2xl py-2xl md:px-3xl lg:px-4xl">
      <div className="mx-auto grid max-w-[1272px] grid-cols-2 gap-lg sm:grid-cols-4">
        {trustItems.map(item => (
          <div key={item} className="flex items-center justify-center gap-x-sm">
            <Check className="size-[18px] shrink-0 text-text-primary" />
            <span className="text-text-strong t-strong-sm">{item}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
